import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=7af14fe7&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports